import { useLocation } from "react-router-dom";
import MyChart from "../../components/Chart/Chart";
import { useProvienceChart } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { CrmChartStyle } from "./CrmChartStyle";

const CrmChart = () => {
  const dat = useLocation();
  const { data: chart, isLoading } = useProvienceChart(dat.state);

  let proviences = [];
  let amount = [];
  let count = [];
  chart?.data?.mashad.map((item) => {
    proviences.push(item?.Provinces);
    amount.push(item?.Price);
    count.push(item?.Count);
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        intersect: false,
      },
      title: {
        display: true,
        text: "نمودار فروش به تفکیک استان",
      },
    },
  };
  const options1 = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        intersect: false,
      },
      title: {
        display: true,
        text: "نمودار تعداد فاکتور به تفکیک استان",
      },
    },
  };
  const labels = proviences;
  const data = {
    labels,
    datasets: [
      {
        label: "فروش",
        data: amount,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };
  const data1 = {
    labels,
    datasets: [
      {
        label: "تعداد فاکتور",
        data: count,
        backgroundColor: "rgba(87, 136, 54, 0.5)",
      },
    ],
  };
  return (
    <CrmChartStyle>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="flex flex-col w-full">
          <MyChart
            data={data}
            sell={"فروش"}
            options={options}
            labels={labels}
          />
          <MyChart
            data={data1}
            sell={"تعداد فاکتور"}
            options={options1}
            labels={labels}
          />
        </div>
      )}
    </CrmChartStyle>
  );
};

export default CrmChart;
